import React from 'react';
import {useSelector} from 'react-redux';
import AdminShop from './admin-shop';

const PartnerShop = () => {
  const profile = useSelector(state => state.login && state.login.profile);
  const name = profile ? (profile.name || profile.businessName || 'Circolo') : 'Circolo';

  return (
    <AdminShop
      scope="partner"
      title={`Shop ${name}`}
      ordersTitle={`Ordini Shop ${name}`}
    />
  );
};

export default PartnerShop;
